import CommodityBalance, { getCommodityBalanceType } from "domain/commodityBalance";
import commodityBalanceService, { CommodityBalanceRequestFilter } from "../commodityBalance/commodityBalance.service";
import useAjaxCall from "common/ui/useAjaxCall";
import IsLoaded from "common/isLoaded";
import { useState } from "react";
import { withCancellationToken } from "common/http/httpService";
import loggingService from "common/logging/loggingService";
import Offer from "domain/offer";
import useActiveMerchant from "features/merchants/useActiveMerchant";
import useStoreSelector from "common/redux/useStoreSelector";

const emptyResult: IsLoaded<CommodityBalance | null> = { isLoaded: true, data: null };
export default function useCommodityBalance(offer: NullishPartial<Offer>, shouldLoad: () => boolean): IsLoaded<CommodityBalance | null> {
    const [result, setResult] = useState<IsLoaded<CommodityBalance | null>>({ isLoaded: false, data: null });

    const activeMerchant = useActiveMerchant();
    const isCustomer = useStoreSelector(m => m.userState.isCustomer);

    useAjaxCall(async cxt => {

        if (!shouldLoad()) {
            setResult(emptyResult);
            return;
        }

        const commodityBalanceType = getCommodityBalanceType(offer.deliveryMethod);

        let location = offer.location;
        if (!isCustomer && activeMerchant.generalSettings.displayInventoryLocation) {
            location = offer.inventoryLocation;
        }
        const request: CommodityBalanceRequestFilter = {
            locationId: location?.id,
            commodityId: offer.commodity?.id,
            producerId: offer.producer?.id,
            producerAccountId: offer.customerAccount?.accountId,
            commodityBalanceType: commodityBalanceType,
            offerId: offer.id
        };

        try {
            const x = await withCancellationToken(commodityBalanceService, cxt).getCommodityBalance(request);
            setResult({ isLoaded: true, data: x })
        }
        catch (err) {
            loggingService.error("Unable to retrieve commodity balance", err as Error);
            setResult(emptyResult)
        }
    }, [offer.location, offer.inventoryLocation, offer.commodity, offer.producer, offer.customerAccount, offer.deliveryMethod, offer.delayedContract]);

    return result;
}